import Vue from 'vue';
import { optionsError } from '@/app/configs/OptionToast';
import DatetimePicker from 'vuetify-datetime-picker';
import kbankIcon from '@/assets/icon-bank/KBANK.png';
import bblIcon from '@/assets/icon-bank/BBL.png';
import { APIRequest, APIRequestUpload } from '@/app/services/APIRequest';
import OnlyNumberNotDot from '@/app/helpers/OnlyNumberNotDot';
import GETWarehouse from '@/app/helpers/GETWarehouse';
import store from '@/app/vuex/store';
import Schema from '@/app/schema/Schema';
import compileSchema from '@/app/schema/Compile';
import FocusRef from '@/app/helpers/ForcusRef';
import moment from 'moment';
import { formatCurrency, numberWithComma } from '@/app/helpers/FormatCurrency';
import Navbar from '@/views/components/layouts/Navbar.vue';

Vue.use(DatetimePicker);

export default {
  props: {
    idEdit: String
  },
  components: {
    Navbar
  },
  data: () => ({
    dialogDeleteProductSelected: false,
    dialogDeleteProductSelectedSubmit: false,
    valueItemProductSelected: [],
    findCustomerInput: '',
    searchProduct: '',
    selectedWarehose: null,
    selectedOrderSale: null,
    shippingPrice: null,
    serviceCharge: null,
    blobURL: null,
    valueInput: {
      customerID: null,
      selectCustomer: null,
      orderCustomerName: null,
      orderCustomerSocialName: null,
      orderCustomerPhone: null,
      orderCustomerEmail: null,
      orderCustomerAddress: null,
      orderCustomerPostal: null,
      orderShippingType: null,
      orderShippingBy: null,
      orderVerifyPayment: false,
      orderVerifyCOD: false,
      orderPaymentType: null,
      orderPaymentSelectedBank: null,
      orderPaymentDate: null,
      orderPaymentImage: null,
      orderPaymentCOD: null
    },
    rule:
      {
        orderCustomerName: [
          value => !!value || 'กรุณากรอก ชื่อ - สกุล ลูกค้า',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
        ],
        orderCustomerSocialName: [
          value => !!value || 'กรุณากรอกชื่อโซเชี่ยล',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
        ],
        orderCustomerPhone: [
          value => !!value || 'กรุณากรอกเบอร์โทรศัพท์',
          value => /^[0].*/.test(value) || 'เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0',
          value => (value && value.length === 10) || 'เบอร์โทรศัพท์ตัวเลข 10 ตัว'
        ],
        orderCustomerEmail: [
          value => !!value || 'กรุณากรอกอีเมล์',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
          value => /.+@.+\..+/.test(value) || 'อีเมล์ไม่ถูกต้อง'
        ],
        orderCustomerAddress: [
          value => !!value || 'กรุณากรอกที่อยู่ลูกค้า',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
        ],
        orderCustomerPostal: [
          value => !!value || 'กรุณากรอกรหัสไปรษณีย์'
        ],
        orderSelectedPrice: [
          value => !!value || 'กรุณากรอกราคาขาย',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 บาท',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value < 999999999999) || 'ห้ามเกิน 999,999,999,999 บาท'
        ],
        orderSelectedQTY: [
          value => !!value || 'กรุณากรอกจำนวน',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 ชิ้น',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value < 999999999999) || 'ห้ามเกิน 999,999,999,999 ชิ้น'
        ],
        orderSelectedDiscountPercent: [
          value => !!value || 'กรุณากรอกส่วนลด %',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value < 999999999999) || 'ห้ามเกิน 999,999,999,999 ชิ้น'
        ],
        orderSelectedDiscount: [
          value => !!value || 'กรุณากรอกส่วนลด',
          // eslint-disable-next-line no-restricted-globals
          value => (!isNaN(parseFloat(value)) && value < 999999999999) || 'ห้ามเกิน 999,999,999,999 ชิ้น'
        ]
      },
    customerData: [],
    dialogAddProduct: false,
    textFieldProps: {
      appendIcon: 'mdi-calendar-range',
      outlined: true,
      hideDetails: true,
      dense: true
      // ref: 'orderPaymentDate'
    },
    itemsPaymentType: [
      {
        title: 'Bank Transfer (โอนเงิน)',
        type: 'bank'
      },
      {
        title: 'COD (เก็บเงินปลายทาง)',
        type: 'cod'
      }
    ],
    itemsSale: [
      {
        name: 'ธนบดี บุญจันทร์',
        id: '1'
      },
      {
        name: 'ธวัชชัย ประสิทธิพทย์',
        id: '2'
      }
    ],
    paymentType: null,
    verifyTransfer: false,
    itemsBankTransfer: [
      {
        title: 'KBANK',
        id: 'kbank',
        icon: kbankIcon
      },
      {
        title: 'BBL',
        id: 'bbl',
        icon: bblIcon
      }
    ],
    selectedBank: [
      {
        bank: null,
        dateTime: null,
        verify: false,
        file: null
      }
    ],
    selectedCOD: [
      {
        verify: false,
        shipping: null
      }
    ],
    itemsShippingCOD: [
      {
        title: 'Kerry Express',
        id: 'KERRY'
      }
    ],
    selectedProduct: [],
    headersDataSelectProduct: [
      {
        text: 'รูปภาพ',
        sortable: false,
        value: 'image',
        width: '80px',
        align: 'center'
      },
      {
        text: 'ชื่อสินค้า',
        value: 'name',
        sortable: false
      },
      {
        text: 'ราคาขาย',
        value: 'price',
        sortable: false,
        width: '100px',
        align: 'center'
      },
      {
        text: 'พร้อมขาย',
        value: 'qty',
        sortable: false,
        width: '100px',
        align: 'center'
      }
      // {
      //   text: 'ดำเนินการ',
      //   value: 'action',
      //   sortable: false,
      //   width: '100px',
      //   align: 'center',
      // },
    ],
    itemsTableDataSelectProduct: [],
    headersDataAddProduct: [
      {
        text: 'รูปภาพ',
        sortable: false,
        value: 'image',
        width: '80px',
        align: 'center'
      },
      {
        text: 'ชื่อสินค้า',
        sortable: false,
        value: 'name'
      },
      {
        text: 'รหัสสินค้า',
        sortable: false,
        value: 'code'
      },
      {
        text: 'ราคาขาย',
        sortable: false,
        value: 'price',
        width: '200px',
        align: 'center'
      },
      {
        text: 'จำนวน',
        sortable: false,
        value: 'qtySale',
        width: '200px',
        align: 'center'
      },
      {
        text: 'ส่วนลด %',
        sortable: false,
        value: 'discountPercent',
        width: '120px',
        align: 'center'
      },
      {
        text: 'ส่วนลด (บาท)',
        sortable: false,
        value: 'discount',
        width: '120px',
        align: 'center'
      },
      {
        text: 'ผลรวม',
        sortable: false,
        value: 'total',
        width: '120px',
        align: 'center'
      },
      {
        text: 'ดำเนินการ',
        sortable: false,
        value: 'action',
        width: '100px',
        align: 'center'
      }
    ],
    itemsTableDataAddProduct: [],
    defaultValueTableDataAddProduct: 1
  }),

  computed: {
    totalPrice(){
      let totalPrice = 0;
      this.itemsTableDataAddProduct.map(item => {
        if (item.buyQty){
        // eslint-disable-next-line max-len
          totalPrice += (item.buyQty * item.price) - ((item.buyQty * item.price) * (item.discountPercent / 100)) + (this.shippingPrice ? this.shippingPrice : 0) + (this.serviceCharge ? this.serviceCharge : 0);
          return totalPrice;
        }
        return totalPrice;
      });
      return totalPrice;
    }
  },

  mounted(){
    console.log('this.$route: ', this.$route);
    console.log('this.$props: ', this.$props);
    if (this.$route && this.$route.name === 'OrderEdit' && this.$props && this.$props.idEdit){
      this.getDataEdit();
    }
  },

  methods: {
    moment,
    formatCurrency,
    numberWithComma,
    previewFiles(event){
      this.valueInput.orderPaymentImage = event;
      this.blobURL = URL.createObjectURL(event);
    },

    findCustomer($event){
      const { value } = $event.target;
      let URL;
      if (value.length < 2){
        URL = '/customer/find/a';
      } else {
        URL = `/customer/find/${value}`;
      }
      APIRequest({
        method: 'GET',
        url: URL,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10){
          this.customerData = response.data.result;
        }
      }).catch(error => {
        console.log(error);
      });
    },

    selectCustomer(){
      const dataSelect = this.valueInput.selectCustomer;
      if (dataSelect){
        this.valueInput.orderCustomerName = dataSelect.name;
        this.valueInput.orderCustomerSocialName = dataSelect.nameSocial;
        this.valueInput.orderCustomerPhone = dataSelect.phone;
        this.valueInput.orderCustomerEmail = dataSelect.email;
        this.valueInput.orderCustomerAddress = dataSelect.address;
        this.valueInput.orderCustomerPostal = dataSelect.postal;
      }
    },

    handleInputNumber($event){
      OnlyNumberNotDot($event);
    },

    getWarehouse(){
      GETWarehouse()
        .then(response => {
          if (response && response.code === 10 && response.result){
            this.itemsWarehouse = response.result;
          }
        });
    },

    handleAddProduct(value){
      if (this.$route && this.$route.name === 'OrderCreate'){
        if (value === 'cancel'){
          this.dialogAddProduct = false;
          this.selectedProduct = [];
        } else if (value === 'submit'){
          this.itemsTableDataAddProduct = this.selectedProduct;
          this.dialogAddProduct = false;
        }
      } else if (this.$route && this.$route.name === 'OrderEdit'){
        if (value === 'cancel'){
          this.dialogAddProduct = false;
          this.selectedProduct = [];
        } else if (value === 'submit'){
          const newListData = this.selectedProduct.map(element => {
            const dataLoop = {
              // eslint-disable-next-line dot-notation
              _id: element['_id'],
              image: element.image,
              name: element.name,
              code: element.code,
              price: element.price,
              buyQty: element.buyQty,
              qty: element.qty,
              discountPercent: element.discountPercent,
              discount: element.discount,
              total: element.total
            };
            const list = {
              ...dataLoop
            };
            return list;
          });
          this.itemsTableDataAddProduct = newListData;
          this.dialogAddProduct = false;
        }
      }
    },

    alertDelete(item){
      this.dialogDeleteProductSelected = true;
      this.valueItemProductSelected = item;
    },

    deleteItem(){
      const index = this.itemsTableDataAddProduct.indexOf(this.valueItemProductSelected);
      this.itemsTableDataAddProduct.splice(index, 1);
      this.dialogDeleteProductSelected = false;
    },

    getProduct(){
      store.dispatch('loading/setLoading', true);
      const value = this.searchProduct;
      let URL;
      if (!value){
        URL = '/product/list-create-order';
      } else {
        URL = `/product/find/${value}`;
      }
      APIRequest({
        method: 'GET',
        url: URL,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10){
          this.itemsTableDataSelectProduct = response.data.result;
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        store.dispatch('loading/setLoading', false);
        console.log(error);
      });
    },

    handleInsertData(){
      const data = {
        // eslint-disable-next-line dot-notation
        orderCustomerName: this.valueInput.orderCustomerName,
        orderCustomerSocialName: this.valueInput.orderCustomerSocialName,
        orderCustomerPhone: this.valueInput.orderCustomerPhone,
        orderCustomerEmail: this.valueInput.orderCustomerEmail,
        orderCustomerAddress: this.valueInput.orderCustomerAddress,
        orderCustomerPostal: this.valueInput.orderCustomerPostal,
        orderPaymentType: null,
        orderShippingPrice: this.shippingPrice ? this.shippingPrice : 0,
        orderServiceCharge: this.serviceCharge ? this.serviceCharge : 0,
        orderTotal: this.totalPrice
      };
      let compile;

      if (!this.valueInput.orderPaymentType){
        compile = compileSchema(data, Schema.Order);
      }
      if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === false){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyPayment = this.valueInput.orderVerifyPayment || null;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === true){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyPayment = this.valueInput.orderVerifyPayment || null;
        data.orderPaymentSelectedBank = this.valueInput.orderPaymentSelectedBank
          ? this.valueInput.orderPaymentSelectedBank
          : null;
        data.orderPaymentDate = this.valueInput.orderPaymentDate
          // ? new Date(this.valueInput.orderPaymentDate).toISOString().substring('0, 10')
          ? moment(this.valueInput.orderPaymentDate).format('DD/MM/YYYY hh:mm')
          : null;
        data.orderPaymentImage = this.valueInput.orderPaymentImage ? this.valueInput.orderPaymentImage.name : null;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'cod' && this.valueInput.orderVerifyCOD === false){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyCOD = this.valueInput.orderVerifyCOD || null;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'cod' && this.valueInput.orderVerifyCOD === true){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyCOD = this.valueInput.orderVerifyCOD || null;
        data.orderPaymentCOD = this.valueInput.orderPaymentCOD || null;
        compile = compileSchema(data, Schema.Order);
      }

      if (compile){
        const forcus = FocusRef(compile);
        if (forcus){
          this.$refs[forcus].focus();
        }
      }

      if (compile.pass === true){
        if (this.itemsTableDataAddProduct.length < 1){
          Vue.toasted.show('กรุณาเลือกสินค้า', optionsError);
        } else {
          let hasError = true;
          this.itemsTableDataAddProduct.forEach(element => {
            const itemSchema = {
              ...Schema.Order.properties,
              buyQty: {
                type: 'number',
                minimum: 1,
                maximum: element.qty
              },
              discountPercent: {
                type: 'number',
                minimum: 0,
                maximum: 100
              }
            };

            const compileProductList = compileSchema(element, {
              type: 'object',
              required: ['buyQty'],
              properties: itemSchema
            });

            console.log('compileProductList : ', compileProductList);

            if (compileProductList.pass === false){
              hasError = compileProductList.pass;
            }
          });

          if (hasError === true){
            const productData = {
              product: this.itemsTableDataAddProduct
            };

            let finalData = {
              ...data,
              ...productData
            };

            if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === true){
              const formData = new FormData();
              formData.append('photos', this.valueInput.orderPaymentImage);
              store.dispatch('loading/setLoading', true);
              APIRequestUpload({
                method: 'POST',
                url: '/upload/img',
                data: formData,
                auth: true
              }).then(response => {
                if (response && response.data.code === 10){
                  const newImage = {
                    image: response.data.url
                  };

                  if (response.data.url){
                    finalData = {
                      ...data,
                      ...newImage,
                      ...productData
                    };

                    this.APIInsertData(finalData);
                  }
                }
              }).catch(error => {
                console.log(error);
                store.dispatch('loading/setLoading', false);
              });
            } else if (this.valueInput.orderPaymentType === 'cod'){
              this.APIInsertData(finalData);
            }
          }
        }
      }
    },

    getDataEdit(){
      store.dispatch('loading/setLoading', true);
      const data = {
        id: this.$route.query ? this.$route.query.id : ''
      };
      APIRequest({
        method: 'POST',
        url: '/order/get-order-query-by-id',
        data,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          this.valueInput.orderCustomerName = response.data.result.fullName;
          this.valueInput.orderCustomerSocialName = response.data.result.socialName;
          this.valueInput.orderCustomerPhone = response.data.result.phone;
          this.valueInput.orderCustomerEmail = response.data.result.email;
          this.valueInput.orderCustomerAddress = response.data.result.address;
          this.valueInput.orderCustomerPostal = response.data.result.postalCode;
          this.shippingPrice = response.data.result.shippingPrice;
          this.serviceCharge = response.data.result.serviceCharge;
          if (response.data.result.paymentType === 'cod'){
            this.valueInput.orderPaymentType = response.data.result.paymentType;
            this.valueInput.orderVerifyCOD = response.data.result.verifyCOD === 'true' ? true : '';
            this.valueInput.orderPaymentCOD = response.data.result.paymentCOD;
          }
          if (response.data.result.paymentType === 'bank'){
            this.valueInput.orderPaymentType = response.data.result.paymentType;
            // eslint-disable-next-line dot-notation
            this.valueInput.orderPaymentDate = moment(response.data.result.paymentDate)['_d'];
            this.valueInput.verifyTransfer = response.data.result.orderVerifyPayment;
            this.valueInput.orderVerifyPayment = true;
            this.valueInput.orderPaymentSelectedBank = response.data.result.paymentBank;
            this.blobURL = response.data.result.paymentImage;
            this.valueInput.orderPaymentImage = response.data.result.paymentImage;
          }
          const newListData = response.data.result.products.map(element => {
            const dataLoop = {
              // eslint-disable-next-line dot-notation
              _id: element.idProduct['_id'],
              image: element.idProduct.image,
              name: element.idProduct.name,
              code: element.idProduct.code,
              price: element.price,
              oldQty: element.qty,
              buyQty: element.qty,
              qty: element.idProduct.qty,
              discountPercent: element.discountPercent,
              discount: element.discountBath,
              total: element.total
            };
            const list = {
              ...dataLoop
            };
            return list;
          });

          this.itemsTableDataAddProduct = newListData;
          this.selectedProduct = newListData;
        }
        console.log(this.itemsTableDataAddProduct);
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    },

    handleEditData(){
      const data = {
        // eslint-disable-next-line dot-notation
        orderCustomerName: this.valueInput.orderCustomerName,
        orderCustomerSocialName: this.valueInput.orderCustomerSocialName,
        orderCustomerPhone: this.valueInput.orderCustomerPhone,
        orderCustomerEmail: this.valueInput.orderCustomerEmail,
        orderCustomerAddress: this.valueInput.orderCustomerAddress,
        orderCustomerPostal: this.valueInput.orderCustomerPostal,
        orderPaymentType: null,
        orderShippingPrice: this.shippingPrice ? this.shippingPrice : 0,
        orderServiceCharge: this.serviceCharge ? this.serviceCharge : 0,
        orderTotal: this.totalPrice,
        product: this.itemsTableDataAddProduct
      };
      let compile;

      if (!this.valueInput.orderPaymentType){
        compile = compileSchema(data, Schema.Order);
      }
      if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === false){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyPayment = this.valueInput.orderVerifyPayment || null;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === true){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyPayment = this.valueInput.orderVerifyPayment || null;
        data.orderPaymentSelectedBank = this.valueInput.orderPaymentSelectedBank
          ? this.valueInput.orderPaymentSelectedBank
          : null;
        data.orderPaymentDate = this.valueInput.orderPaymentDate
          ? moment(this.valueInput.orderPaymentDate).format('DD/MM/YYYY hh:mm')
          : null;
        data.orderPaymentImage = this.valueInput.orderPaymentImage
          ? this.valueInput.orderPaymentImage.name
          : this.valueInput.orderPaymentImage;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'cod' && this.valueInput.orderVerifyCOD === false){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyCOD = this.valueInput.orderVerifyCOD || null;
        compile = compileSchema(data, Schema.Order);
      } else if (this.valueInput.orderPaymentType === 'cod' && this.valueInput.orderVerifyCOD === true){
        data.orderPaymentType = this.valueInput.orderPaymentType || null;
        data.orderVerifyCOD = this.valueInput.orderVerifyCOD || null;
        data.orderPaymentCOD = this.valueInput.orderPaymentCOD || null;
        compile = compileSchema(data, Schema.Order);
      }
      if (compile){
        const forcus = FocusRef(compile);
        if (forcus){
          this.$refs[forcus].focus();
        }
      }

      if (compile.pass === true){
        if (this.itemsTableDataAddProduct.length < 1){
          Vue.toasted.show('กรุณาเลือกสินค้า', optionsError);
        } else {
          let hasError = true;
          this.itemsTableDataAddProduct.forEach(element => {
            const itemSchema = {
              ...Schema.Order.properties,
              buyQty: {
                type: 'number',
                minimum: 1,
                maximum: element.qty
              },
              discountPercent: {
                type: 'number',
                minimum: 0,
                maximum: 100
              }
            };

            const compileProductList = compileSchema(element, {
              type: 'object',
              required: ['buyQty'],
              properties: itemSchema
            });

            if (compileProductList.pass === false){
              hasError = compileProductList.pass;
            }
          });

          if (hasError === true){
            const productData = {
              product: this.itemsTableDataAddProduct
            };

            let newImage = {
              image: this.valueInput.orderPaymentImage
            };

            const IDEdit = {
              id: this.$props.idEdit
            };

            let finalData = {
              ...IDEdit,
              ...data,
              ...newImage,
              ...productData
            };

            if (this.valueInput.orderPaymentType === 'bank' && this.valueInput.orderVerifyPayment === true){
              if (this.valueInput.orderPaymentImage && this.valueInput.orderPaymentImage.name){
                const formData = new FormData();
                formData.append('photos', this.valueInput.orderPaymentImage);
                store.dispatch('loading/setLoading', true);
                APIRequestUpload({
                  method: 'POST',
                  url: '/upload/img',
                  data: formData,
                  auth: true
                }).then(response => {
                  if (response && response.data.code === 10){
                    newImage = {
                      image: response.data.url
                    };

                    if (response.data.url){
                      finalData = {
                        ...IDEdit,
                        ...data,
                        ...newImage,
                        ...productData
                      };

                      this.APIInsertData(finalData);
                    }
                  }
                }).catch(error => {
                  console.log(error);
                  store.dispatch('loading/setLoading', false);
                });
              } else {
                this.APIInsertData(finalData);
              }
            } else if (this.valueInput.orderPaymentType === 'cod'){
              this.APIInsertData(finalData);
            }
          }
        }
      }
    },

    APIInsertData(dataInsert){
      let method;
      if (this.$route && this.$route.name === 'OrderEdit' && this.$props && this.$props.idEdit){
        method = 'PUT';
      } else {
        method = 'POST';
      }
      store.dispatch('loading/setLoading', true);
      APIRequest({
        method,
        url: '/order/',
        data: dataInsert,
        auth: true
      }).then(response => {
        if (response && response.data.code === 0){
          this.$router.push({ name: 'Order' });
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    }
  }
};
